// extracted by mini-css-extract-plugin
export default {"head":"HeadStep_head__-Wdd8","stepWrap":"HeadStep_stepWrap__hVv3+","step":"HeadStep_step__6XtUZ"};